module.exports = __webpack_public_path__ + "img/creature_hit.6006cb84.svg";